import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import { useScrollLock } from "../../../hooks/useScrollLock"
import { useLocation } from "react-router-dom"
import { showModal } from "../../../features/modal/modalSlice"
import Button from "../../shared/Button"
import InputDate from "../../shared/input/new/InputDate"
import { getShipmentReportExcel } from "../../../features/reports/reportSlice"

const ModalContainer = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: 600px;
        min-height: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        border: 1px solid;
        border-color: ${({ theme }) => theme.mainBorderColor};
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        overflow: auto;
    }

    .content{
        margin-block: 20px;
        padding: 0 30px;
        display: flex;
        flex-direction: column;
        height: 100%;
        width: 100%;
        gap: 30px;
    }

    .title-area{
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    .title-area h2{
        font-size: var(--font-size-lg);
        font-weight: var(--font-weight-xl);
        color: ${({ theme }) => theme.mainTextColor};
    }

    .title-area p{
        font-size: var(--font-size-sm);
        color: ${({ theme }) => theme.secondaryTextColor};
    }

    .date-area{
        display: flex;
        gap: 20px;
        align-items: center;
        flex-wrap: wrap;
    }

    .error-message{
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-md);
        color: var(--color-red);
    }

    .button-grp{
        width: 100%;
        display: flex;
        justify-content: center;
        gap: 20px;
        padding: 0 30px 30px 30px;
    }
`

const SevkiyatRaporuModal = () => {
    const dispatch = useDispatch()
    const location = useLocation()

    const { modalLocation } = useSelector(state => state.modal)
    const { isLoadingShipmentReportExcel } = useSelector(state => state.report)

    const { lockScroll, unlockScroll } = useScrollLock()

    const [dateValues, setDateValues] = useState({
        startDate: "",
        endDate: ""
    })

    const [errorMessage, setErrorMessage] = useState("")

    //! bu modal açıldığında ekranı locklamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])

    //! başka bir sayfaya geçildiğinde modalı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

    const handleDateChange = (e) => {
        const { name, value } = e.target

        setDateValues(prev => ({
            ...prev,
            [name]: value
        }))

        setErrorMessage("")
    }

    const handleDownload = async () => {
        if (isLoadingShipmentReportExcel) return

        if (!dateValues.startDate || !dateValues.endDate) {
            setErrorMessage("Lütfen başlangıç ve bitiş tarihi seçiniz.")
            return
        }

        if (dateValues.startDate > dateValues.endDate) {
            setErrorMessage("Başlangıç tarihi bitiş tarihinden büyük olamaz.")
            return
        }

        try {
            await dispatch(getShipmentReportExcel({
                startDate: dateValues.startDate,
                endDate: dateValues.endDate
            })).unwrap()
        } catch (error) {
            setErrorMessage(
                typeof error === "string"
                    ? error
                    : "Sevkiyat raporu indirilirken bir hata oluştu."
            )
        }
    }

    return (
        <ModalContainer onClick={() => dispatch(showModal(null))}>
            <div className="modal" onClick={(e) => e.stopPropagation()}>
                <div className="content">
                    <div className="title-area">
                        <h2>Sevkiyat Raporu</h2>
                        <p>Seçtiğiniz tarih aralığındaki sevkiyat raporunu Excel olarak indirebilirsiniz.</p>
                    </div>

                    <div className="date-area">
                        <InputDate
                            data={dateValues.startDate}
                            setData={handleDateChange}
                            name="startDate"
                            labelText="Başlangıç Tarihi"
                            inputWidth="250px"
                        />

                        <InputDate
                            data={dateValues.endDate}
                            setData={handleDateChange}
                            name="endDate"
                            labelText="Bitiş Tarihi"
                            inputWidth="250px"
                            min={dateValues.startDate}
                        />
                    </div>

                    {errorMessage && (
                        <div className="error-message">
                            {errorMessage}
                        </div>
                    )}
                </div>

                <div className="button-grp">
                    <Button
                        color={"#F4F4F4"}
                        background={"#E85446"}
                        width="220px"
                        radius={"10px"}
                        text={isLoadingShipmentReportExcel ? "İndiriliyor..." : "Raporu İndir"}
                        handleClick={handleDownload}
                    />

                    <Button
                        color={"#E85446"}
                        background={"#fff"}
                        
                        width="220px"
                        radius={"10px"}
                        text={"Geri Dön"}
                        handleClick={() => dispatch(showModal(null))}
                    />
                </div>
            </div>
        </ModalContainer>
    )
}

export default SevkiyatRaporuModal